export default {
  BusinessReportStockDeliver: {
    deliveryTime: '发货时间',
    warehouseIds: '仓库',
    logisticsCompanyIds: '物流商',
    subtotal: '小计',
    shippingQty: '发货单数',
    packageQty: '包裹数',
    goodsQty: '发货商品数',
    postageTotal: '运费合计',
    collectTypeOptions1: '按仓库',
    collectTypeOptions2: '按物流商',
    total: '合计'
  }
};
